/**
 * Pure sorting helpers — no store/model deps so they stay trivially testable.
 */
import { BOOKMARK_SORT_FIELDS } from '@/utils/constants'

/**
 * Returns a sortOrder one below the current minimum (or -1 if none).
 * Regular items render by sortOrder asc, so the smallest sorts to the top.
 */
export const nextTopSortOrder = sortOrders =>
  (sortOrders.length ? Math.min(...sortOrders) : 0) - 1

/**
 * Maps a collection's `defaultSorting` setting ({ sortBy, asc }) to the store's
 * sorting tuple ([field, asc]), or null when absent/unknown.
 */
export const defaultSortingToSorting = defaultSorting => {
  const { sortBy, asc } = defaultSorting || {}
  return sortBy && BOOKMARK_SORT_FIELDS[sortBy] ? [BOOKMARK_SORT_FIELDS[sortBy], !!asc] : null
}
